interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
  theme?: "light" | "dark";
}

export default function SectionHeading({ eyebrow, title, desc, align = "center", theme = "light" }: SectionHeadingProps) {
  const isCenter = align === "center";
  const textMain = theme === "light" ? "text-foreground-950" : "text-background-50";
  const textSub = theme === "light" ? "text-foreground-600" : "text-background-50/75";

  return (
    <div className={`${isCenter ? "mx-auto text-center" : ""} max-w-2xl`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-800">
        <i className="ri-fire-line"></i>
        {eyebrow}
      </span>
      <h2 className={`mt-4 font-heading text-2xl font-bold md:text-4xl ${textMain}`}>{title}</h2>
      {desc && <p className={`mt-4 text-sm leading-7 md:text-base ${textSub}`}>{desc}</p>}
    </div>
  );
}